import script from "./OrganizationContractGroupEvents.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrganizationContractGroupEvents.vue?vue&type=script&setup=true&lang=ts"

import "./OrganizationContractGroupEvents.vue?vue&type=style&index=0&id=c00930fe&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c00930fe"]])

export default __exports__